/* * /
export const getCurrentPosition = (options = {}) => {
	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(resolve, reject, options);
	});
};
/* */

/* */
// https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API/Using_the_Permissions_API
export const getCurrentPosition = (options = {}) => {
	return new Promise((resolve, reject) => {
		if (navigator.permissions) {
			navigator.permissions
				.query({
					name: 'geolocation',
				})
				.then((permission) =>
					// is geolocation granted?
					permission.state === 'granted' || permission.state === 'prompt'
						? navigator.geolocation.getCurrentPosition(resolve, reject, options)
						: reject({ code: 1, message: 'User denied Geolocation' })
				)
				.catch((err) => reject(err));
		} else {
			navigator.geolocation.getCurrentPosition(resolve, reject, options);
		}
	});
};
/* */
